import { AnyDateType, formatDate as _formatDate } from '@art-suite/art-core-ts';

/**
 * @deprecated Use formatDate instead
 */
export const formatScanDate = (value?: AnyDateType | undefined, yearLength = 2) =>
  value ? _formatDate(value, yearLength === 2 ? 'MM-dd-yy' : 'MM-dd-yyyy') : '--';

/**
 * @deprecated Use formatDateTime instead
 */
export const formatScanDateTime = (value: AnyDateType | undefined) => value ? _formatDate(value, 'MM-dd-yyyy h:mmaaa') : '--';

export const formatDate = (value?: AnyDateType | undefined, yearLength = 2) => value ? _formatDate(value, yearLength === 2 ? 'MM-dd-yy' : 'MM-dd-yyyy') : '--';

export const formatDateTime = (value: AnyDateType | undefined) => value ? _formatDate(value, 'MM-dd-yyyy h:mmaaa') : '--';

/**
 * A timestamp without its year: "Apr 1, 4:11pm".
 *
 * For a moment read somewhere the year is already established by its surroundings — a photo inside a
 * dated bucket, say. The day is carried as well as the time because the surrounding date may cover a
 * stretch rather than a day: grouped by week or by month, the time alone would not say which day.
 *
 * Plain day number, no ordinal suffix, matching every other date this app prints.
 */
export const formatMonthDayTime = (value: AnyDateType | undefined) => value ? _formatDate(value, 'MMM d, h:mmaaa') : '--';
